// extracted by mini-css-extract-plugin
export var label = "_jj-2";
export var slideContainer = "_jj-0";
export var slider = "_jj-1";